import * as React from 'react';
import { ToastType } from 'common/components/toast/types';
import { addToast } from 'common/components/toast-area/toast-manager';
import { openDemoProjectSelectorModal } from 'common/widgets/demo-selector-modal';
import { react2panel } from 'common/util/react2panel';
import { Trans } from 'common/i18n';
import { useTranslation } from 'common/i18n/hooks';
const ViewDemoBoardHelpText = () => {
  const {
    t
  } = useTranslation();
  return <div className={"help-text"} data-sentry-component="ViewDemoBoardHelpText" data-sentry-source-file="empty-hero-react.tsx">
      <Trans i18nKey={"boards.empty-hero.help-text"} t={t} components={{
      demoLink: <a onClick={() => {
        openDemoProjectSelectorModal(ev => {
          addToast({
            message: ev.detail.message,
            type: ToastType.ERROR
          });
        });
      }} />
    }} data-sentry-element="Trans" data-sentry-source-file="empty-hero-react.tsx" />
    </div>;
};
export const ViewDemoBoardHelpTextEl = react2panel("mp-demo-board-help-text", ViewDemoBoardHelpText);